import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        onLogin(data);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Error de conexión. Verifica que el backend esté corriendo');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setMessage(data.message);
        setEmail('');
        setPassword('');
        setIsRegister(false);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Error de conexión. Verifica que el backend esté corriendo');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>CONTADOR DE EFECTIVO</h2>
        <h3>Iniciar Sesión</h3>
        
        <form onSubmit={isRegister ? handleRegister : handleLogin}>
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit">{isRegister ? 'Registrarse' : 'Ingresar'}</button>
        </form>
        
        <button 
          onClick={() => {
            setIsRegister(!isRegister);
            setError('');
            setMessage('');
          }}
          className="toggle-btn"
        >
          {isRegister ? 'Ya tengo cuenta' : 'Crear cuenta'}
        </button>
        
        {error && <div className="error">{error}</div>}
        {message && <div className="success">{message}</div>}
        

      </div>
    </div>
  );
};

export default Login;